import { render, staticRenderFns } from "./GTextEditor.vue?vue&type=template&id=44def78a&"
import script from "./GTextEditor.vue?vue&type=script&lang=js&"
export * from "./GTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./GTextEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports